import { render, staticRenderFns } from "./MultiValueEditor.vue?vue&type=template&id=2d3fe8b4&"
import script from "./MultiValueEditor.vue?vue&type=script&lang=js&"
export * from "./MultiValueEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports